import React, { Component } from 'react';

class InspirationForm extends Component{
    constructor(props){
        super(props);
        this.state = {
          inspiration:{
            url:'',
            contents:''
          }
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount(){
      this.setState({
        inspiration:{
          url:'',
          contents:''
        }
      })
    }

    handleInputChange(e) {
        let temp_inspiration = Object.assign({}, this.state.inspiration);
        temp_inspiration[e.target.name] = e.target.value;
        this.setState({inspiration:temp_inspiration});
    }

    render(){
        const {event, modalBackgroundHandler, saveInspiration} = this.props;
        const {inspiration} = this.state;
        return (
        <React.Fragment>
          <div className="modal-header">
              <h4 className="modal-title">Add Inspiration Idea</h4>
              <button type="button" className="close" onClick={modalBackgroundHandler} aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
          </div>
          <div className="modal-body">
            <div className="card">
              <div className="card-body">
                <div className="form-group">
                    <label>Website URL</label>
                    <input className="form-control" name="url" type="text" onChange={this.handleInputChange} value={inspiration.url}/>
                </div>
                <div className="form-group">
                    <label>Comments - Let us know what you like or what we should look for.</label>
                    <textarea className="form-control" name="contents" onChange={this.handleInputChange} value={inspiration.contents}></textarea>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
              <button type="button" className={this.state.inspiration.url !== '' ? "btn btn-primary" : "btn btn-primary disabled"} onClick={()=>saveInspiration(this.state.inspiration, event, 'add')}>
                Save
              </button>
              <button type="button" className="btn btn-secondary" onClick={modalBackgroundHandler}>
                Close
              </button>
          </div>
        </React.Fragment>
        );
    }
}

export default InspirationForm;



// WEBPACK FOOTER //
// ./src/components/client/InspirationForm.js